import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { displays } from 'investira.react.lib';
import {
  Stack,
  Typography,
  IconButton,
  Icon,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  ListItemText,
  Card
} from 'investira.react.components';
import { PessoaImage } from '../../../components/molecules';

const FeederMasterListItem = memo(props => {
  const { relationship, pessoasById, onRemove, onModify } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  function handleMenuOpen(pEvent) {
    setAnchorEl(pEvent.currentTarget);
  }

  function handleMenuClose() {
    setAnchorEl(null);
  }

  function handleModify() {
    onModify({ feeder, master });
    handleMenuClose();
  }

  function handleRemove() {
    handleMenuClose();
    onRemove({ feeder, master });
  }

  const feeder = pessoasById?.[String(relationship?.pessoa_id)] || null;
  const master = pessoasById?.[String(relationship?.master_pessoa_id)] || null;

  const renderPessoa = (pLabel, pPessoa) => {
    const nome = pPessoa?.pessoa_fantasia || pPessoa?.pessoa || 'Pessoa não encontrada';
    const razao = pPessoa?.pessoa || 'Pessoa não encontrada';

    return (
      <Stack flex={1} minWidth={0}>
        <Typography variant="caption" color="textSecondary" gutterBottom>
          {pLabel}
        </Typography>

        <Stack direction="row" spacing={1.5} alignItems="flex-start">
          <Stack pt={0.3}>
            <PessoaImage
              logoPessoaId={pPessoa?.logo_pessoa_id}
              alt={nome}
              hasLogo={pPessoa?.logo_ok}
              size={32}
            />
          </Stack>

          <Stack minWidth={0}>
            <Typography variant="body2" color="textPrimary" sx={{ fontWeight: 600 }}>
              {nome}
            </Typography>
            <Typography variant="caption" color="textSecondary" noWrap>
              {razao}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {pPessoa?.cnpj ? displays.cnpj(pPessoa.cnpj) : '-'}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    );
  };

  return (
    <Card
      component="li"
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '70% 30%',
          sm: '90% 10%'
        },
        gap: 2,
        px: 2,
        py: 2,
        mb: 1.5,
        backgroundColor: 'background.paper',
        '&:hover': {
          backgroundColor: 'background.main'
        }
      }}>
      <Stack
        direction={{
          xs: 'column',
          sm: 'row'
        }}
        gap={1.5}>
        {renderPessoa('Feeder', feeder)}
        <Divider flexItem orientation={'vertical'} />
        {renderPessoa('Master', master)}
      </Stack>

      <Stack justifyContent={{ xs: 'flex-start', sm: 'center' }} alignItems="flex-end" pr={2}>
        <IconButton onClick={handleMenuOpen} color="primary">
          <Icon iconName="more" />
        </IconButton>
        <Menu id={`feeder-master-menu`} anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
          <MenuItem onClick={handleModify}>
            <ListItemIcon>
              <Icon iconName="edit" size={16} color="textPrimary" />
            </ListItemIcon>
            <ListItemText>Alterar vínculo</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleRemove}>
            <ListItemIcon>
              <Icon iconName="delete" size={16} color="error" />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ color: 'error' }}>Remover vínculo</ListItemText>
          </MenuItem>
        </Menu>
      </Stack>
    </Card>
  );
});

FeederMasterListItem.propTypes = {
  relationship: PropTypes.shape({
    pessoa_id: PropTypes.number,
    master_pessoa_id: PropTypes.number
  }),
  pessoasById: PropTypes.object,
  onRemove: PropTypes.func,
  onModify: PropTypes.func
};

FeederMasterListItem.defaultProps = {
  relationship: {},
  pessoasById: {},
  onRemove: () => {},
  onModify: () => {}
};

FeederMasterListItem.displayName = 'FeederMasterListItem';

export default FeederMasterListItem;
